<div class="py-1 bg-black top">
    <div class="container">
        <div class="row no-gutters d-flex align-items-start align-items-center px-md-0">
            <div class="col-lg-12 d-block">
                <div class="row d-flex">
                    <div class="col-md pr-4 d-flex topper align-items-center">
                        <!-- <div class="icon mr-2 d-flex justify-content-center align-items-center"></div> -->
                        <span class="text btn btn-success"><i class="fab fa-whatsapp mr-1" ></i> <a href="https://wa.me/{{ empresa.whatsapp }}"  target="_blank"> <span class="text-white"> {{ empresa.phone }}</span></a>
                        </span>
                    </div>
                    <div class="col-md-5 pr-4 d-flex topper align-items-center text-lg-right justify-content-end">
                        <p class="mb-0 register-link"><span class="text-warning">Desayuno buffet Domingos de 8am a 2pm</span></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
